import { render, staticRenderFns } from "./DesktopMenu.vue?vue&type=template&id=3c86b0c0&scoped=true&"
import script from "./DesktopMenu.vue?vue&type=script&lang=js&"
export * from "./DesktopMenu.vue?vue&type=script&lang=js&"
import style0 from "./DesktopMenu.vue?vue&type=style&index=0&id=3c86b0c0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c86b0c0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
installComponents(component, {VFlex,VIcon,VNavigationDrawer})
